import React, { Fragment, useState, useEffect, useContext } from 'react'
import { useLocation, useParams, Link } from 'react-router-dom'
import { getUsers } from '../../store/auth/actions'
import NotesDropdown from './notesDropdown'
import './styles.scss'
import { connect, useDispatch } from 'react-redux'
import { selectUser } from '../../store/auth/selectors'
import { S3_ROOT_URL, THERAPIST_PROFILE_FOLDER } from '../../config'
import SettingSecContainer from './SettingsSec'
import TalkieTotSettings from './talkieTotSettings'
import PrepositionSettings from '../../components/games/Preposition/settings'
import FollowingDirectionSettings from './FollowingDirectionSettings'
import Notifications from './notifications'
import CustomerSupportModal from './CustomerSupportModal'
import HelpPanel from './HelpPanel'
import { useSelector } from 'react-redux'
import { loadSupportWidget } from '../../utils/supportWidget'
import { signOut } from '../../utils/keepAlive'
import AvatarChild from '../common/AvatarChild/AvatarChild'
import './student-header.scss'
import { TimeTracker } from '../common/TimeTracker/TimeTracker'
import useOnClickOutside from '../../hooks/use-onclick-outside'
import { useRef } from 'react'
import { setGameFilter } from '../../store/gameFilter/actions'
import { AudioContext } from '../../store/AudioContext/AudioContext'
import { pressable } from '../../utils/pressable'
const Header = (props) => {
    const loginTypeFlag = useSelector((state) => state.auth.user)
    // Support chat for clinicians only, never on the students' screens.
    useEffect(() => {
        if (loginTypeFlag?.role === 'therapist') {
            loadSupportWidget()
        }
    }, [loginTypeFlag?.role])
    const [showDropDown, setShowDropDown] = useState(false)
    const [displaySettingsIcon, setDisplaySettingsIcon] = useState(true)
    const [displaySettings, setDisplaySettings] = useState(false)
    const [showNotification, setShowNotification] = useState(false)
    const [notificationCount, setNotificationCount] = useState(0)
    const [customerSupport, setCustomerSupport] = useState(false)
    const [helpOpen, setHelpOpen] = useState(false)
    const location = useLocation()
    const dispatch = useDispatch()
    const { activityGame, sessionId } = useParams()
    const { setAudioData } = useContext(AudioContext)

    const ref = useRef()
    useOnClickOutside(ref, () => setShowNotification(false))

    useEffect(() => {
        props.getUsers()
        if (
            location.pathname.includes('go-together') ||
            location.pathname.includes('fun-functional') ||
            location.pathname.includes('reading-comprehensions') ||
            location.pathname.includes('stories') ||
            location.pathname.includes('words-farm') ||
            location.pathname.includes('apraxia-farm') ||
            location.pathname.includes('social-quest') ||
            location.pathname.includes('adjective-remix') ||
            location.pathname.includes('verb-quest') ||
            location.pathname.includes('is-that-silly') ||
            location.pathname.includes('ipractice-verbs') ||
            location.pathname.includes('yes-no-barn') ||
            location.pathname.includes('text-image-match') ||
            location.pathname.includes('image-text-match') ||
            location.pathname.includes('read-and-answer') ||
            location.pathname.includes('phrase-builder') ||
            location.pathname.includes('picture-naming') ||
            location.pathname.includes('sentence-completion') ||
            location.pathname.includes('sound-windows') ||
            location.pathname.includes('picture-identification') ||
            location.pathname.includes('whquestions') ||
            location.pathname.includes('divergent-naming') ||
            location.pathname.includes('figurative') ||
            location.pathname.includes('why') ||
            location.pathname.includes('predicting') ||
            location.pathname.includes('which') ||
            location.pathname.includes('inferencing') ||
            location.pathname.includes('how') ||
            location.pathname.includes('vocabulary') ||
            location.pathname.includes('sequencing') ||
            location.pathname.includes('xray-phono') ||
            location.pathname.includes('sentence-experiment') ||
            location.pathname.includes('decoding-room') ||
            location.pathname.includes('rhyming-selection') ||
            location.pathname.includes('rhyming-match') ||
            location.pathname.includes('rhyming-identification') ||
            location.pathname.includes('find-the-picture') ||
            location.pathname.includes('which-is-not-pronoun') ||
            location.pathname.includes('pronoun-heroes') ||
            location.pathname.includes('select-the-pronoun') ||
            location.pathname.includes('bakery') ||
            location.pathname.includes('pronoun-type-guide') ||
            location.pathname.includes('what-pronoun-guide') ||
            location.pathname.includes('grammar-ski') ||
            location.pathname.includes('zoo') ||
            location.pathname.includes('grocery') ||
            location.pathname.includes('letter-names') ||
            location.pathname.includes('would-rather') ||
            location.pathname.includes('does-not-belong') ||
            location.pathname.includes('picturematching') ||
            location.pathname.includes('where-does-it-go') ||
            location.pathname.includes('beginning-sounds') ||
            location.pathname.includes('learning-about-you') ||
            location.pathname.includes('smart-oral-motor') ||
            location.pathname.includes('sorting') ||
            location.pathname.includes('category-naming') ||
            location.pathname.includes('minimal-pairs-academy') ||
            location.pathname.includes('tic-tac-toe') ||
            location.pathname.includes('wouldyourather_en') ||
            location.pathname.includes('ditm') ||
            location.pathname.includes('worddecoder')
        ) {
            setDisplaySettingsIcon(false)
        }
    }, [])

    const dropDownHandler = () => {
        setShowDropDown(!showDropDown)
        if (!showDropDown) {
            // Opens on the first student's notes.
            const myStudents = document.querySelectorAll('#note_dropdown .notes-tab')
            if (myStudents.length > 0) {
                myStudents[0].click()
            }
        }
    }
    const userRedirect = () => {
        window.location.replace(process.env.REACT_APP_PAGE_BACKEND + 'users')
    }
    // Log out ends the sign-in on our side too (keepAlive.js signOut).
    const logout = () => signOut(process.env.REACT_APP_PAGE_BACKEND + 'login')
    // Students sign back in on the student login page, not the clinicians' one.
    const studentLogout = () => signOut(process.env.REACT_APP_PAGE_BACKEND + 'student-login')

    const slideToggle = () => {
        setDisplaySettings(!displaySettings)
    }
    const toggleNotifications = () => setShowNotification((open) => !open)
    const notificationsLabel = notificationCount > 0 ? `Notifications, ${notificationCount} new` : 'Notifications'
    // Escape closes the notifications and puts the keyboard back on the bell.
    const notificationsKeys = (e) => {
        if (e.key === 'Escape' && showNotification) {
            setShowNotification(false)
            const bell = e.currentTarget.querySelector('[data-bell]')
            bell && bell.focus()
        }
    }

    const rendererSettings = () => {
        if (location.pathname.includes('talkie-tot')) {
            return (
                <TalkieTotSettings
                    handleClose={() => setDisplaySettings(false)}
                />
            )
        } else if (location.pathname.includes('following-directions')) {
            return (
                <FollowingDirectionSettings
                    sessionId={sessionId}
                    handleClose={() => setDisplaySettings(false)}
                />
            )
        } else if (location.pathname.includes('preposition')) {
            return (
                <PrepositionSettings
                    handleClose={() => setDisplaySettings(false)}
                />
            )
        } else {
            return (
                <SettingSecContainer
                    handleClose={() => setDisplaySettings(false)}
                />
            )
        }
    }
    const handleHomeClick = () => {
        setAudioData({ url: '', isPlaying: false })
        dispatch(setGameFilter({ value: 'all' }))
    }

    return (
        <Fragment>
            {loginTypeFlag?.role === 'therapist' ? (
                <header className="th-header">
                    <div className="data">
                        <div className="logo">
                            <Link to="/">
                                <img
                                    src={'/assets/imgs/smarty-ears-logo.png'}
                                    alt="logo"
                                />
                            </Link>
                        </div>
                        <div className="links">
                            {props.therapistDetails.user ? (
                                <a className="th-me">
                                    <img
                                        src={`${THERAPIST_PROFILE_FOLDER}${props.therapistDetails.user.avatar}`}
                                        alt=""
                                    />
                                    <span className="th-name">
                                        {props.therapistDetails.user.first_name}{' '}
                                        {props.therapistDetails.user.last_name}
                                    </span>
                                </a>
                            ) : (
                                ''
                            )}
                            {location.pathname === '/' ||
                            location.pathname === '/select-activity' ? (
                                <Fragment>
                                    <a onClick={userRedirect} {...pressable(userRedirect)} title="Your students and reports" aria-label="Your students and reports">
                                        <i className="fas fa-chart-bar" aria-hidden="true"></i>
                                    </a>
                                    {/* The list sits beside the bell, not inside it: a screen reader reads nothing inside a button. */}
                                    <span ref={ref} className="notify-wrap" onKeyDown={notificationsKeys}>
                                        <a
                                            data-bell
                                            onMouseDown={toggleNotifications}
                                            {...pressable(toggleNotifications, { expanded: showNotification })}
                                            className="notify-main"
                                            title="Notifications"
                                            aria-label={notificationsLabel}
                                        >
                                            <i className="fas fa-bell" aria-hidden="true"></i>{' '}
                                            {notificationCount > 0 && (
                                                <span className="notify-sub" aria-hidden="true">
                                                    {notificationCount}
                                                </span>
                                            )}
                                        </a>
                                        <Notifications
                                            notificationCount={(count) =>
                                                setNotificationCount(count)
                                            }
                                            show={showNotification}
                                            handleClose={() =>
                                                setShowNotification(false)
                                            }
                                            loginTypeFlag={loginTypeFlag}
                                        />
                                    </span>
                                    <a className="th-help" onClick={() => setHelpOpen(true)} {...pressable(() => setHelpOpen(true))} title="Help" aria-label="Help">
                                        <i className="fas fa-question-circle" aria-hidden="true"></i>
                                        <span>Help</span>
                                    </a>
                                    <a onClick={logout} {...pressable(logout)} title="Log out" aria-label="Log out">
                                        <i className="fas fa-sign-out-alt" aria-hidden="true"></i>
                                    </a>
                                </Fragment>
                            ) : (
                                <Fragment>
                                    <Link to="/" onClick={handleHomeClick} title="Your students" aria-label="Your students">
                                        <i className="fas fa-home" aria-hidden="true"></i>
                                    </Link>
                                    {loginTypeFlag?.role === 'therapist' ? (
                                        <Link
                                            to="/select-activity"
                                            onClick={() =>
                                                setAudioData({
                                                    url: '',
                                                    isPlaying: false,
                                                })
                                            }
                                            title="Change activity"
                                            aria-label="Change activity"
                                        >
                                            <i className="fas fa-sync-alt" aria-hidden="true"></i>
                                        </Link>
                                    ) : (
                                        <Link
                                            to="/student-activity"
                                            onClick={() =>
                                                setAudioData({
                                                    url: '',
                                                    isPlaying: false,
                                                })
                                            }
                                            title="Change activity"
                                            aria-label="Change activity"
                                        >
                                            <i className="fas fa-sync-alt" aria-hidden="true"></i>
                                        </Link>
                                    )}

                                    <a
                                        onClick={dropDownHandler}
                                        {...pressable(dropDownHandler, { expanded: showDropDown })}
                                        id="dropdownHandler"
                                        title="Session notes"
                                        aria-label="Session notes"
                                    >
                                        <i className="fas fa-file-alt" aria-hidden="true"></i>
                                    </a>
                                    <a className="th-help" onClick={() => setHelpOpen(true)} {...pressable(() => setHelpOpen(true))} title="Help" aria-label="Help">
                                        <i className="fas fa-question-circle" aria-hidden="true"></i>
                                        <span>Help</span>
                                    </a>
                                    {displaySettingsIcon && (
                                        <a
                                            onMouseDown={slideToggle}
                                            {...pressable(slideToggle, { expanded: displaySettings })}
                                            title="Activity settings"
                                            aria-label="Activity settings"
                                        >
                                            <i className="fas fa-cog" aria-hidden="true"></i>
                                        </a>
                                    )}
                                    {displaySettings && rendererSettings()}
                                </Fragment>
                            )}
                        </div>
                    </div>
                </header>
            ) : loginTypeFlag?.role === 'student' ? (
                <header className="stu-header">
                    <div className="stu-header-in">
                        <Link to="/student-activity" className="stu-header-logo" aria-label="My lessons">
                            <img src="/assets/images/student-home/smarty-ears-logo.png" alt="Smarty Ears" width="120" height="71" />
                        </Link>
                        <div className="stu-header-right">
                            {location.pathname !== '/student-activity' && (
                                <Link to="/student-activity" className="stu-header-home">
                                    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
                                        <path d="M4 11l8-7 8 7v9h-5v-6H9v6H4z" fill="currentColor" />
                                    </svg>
                                    My lessons
                                </Link>
                            )}
                            {props.therapistDetails.user && (
                                <span className="stu-header-me">
                                    <span className="stu-header-avatar">
                                        <AvatarChild avatar={props.therapistDetails.user.avatar} />
                                    </span>
                                    {props.therapistDetails.user.first_name}
                                </span>
                            )}
                            <span ref={ref} className="notify-wrap" onKeyDown={notificationsKeys}>
                                <a
                                    data-bell
                                    className="stu-header-icon"
                                    aria-label={notificationsLabel}
                                    onMouseDown={toggleNotifications}
                                    {...pressable(toggleNotifications, { expanded: showNotification })}
                                >
                                    <i className="fas fa-bell" aria-hidden="true"></i>
                                    {notificationCount > 0 && <span className="badge" aria-hidden="true">{notificationCount}</span>}
                                </a>
                                <Notifications
                                    style={{ right: '-1.2vw' }}
                                    notificationCount={(count) => setNotificationCount(count)}
                                    show={showNotification}
                                    handleClose={() => setShowNotification(false)}
                                />
                            </span>
                            {!location.pathname.includes('student-activity') && displaySettingsIcon && (
                                <a
                                    onMouseDown={slideToggle}
                                    {...pressable(slideToggle, { expanded: displaySettings })}
                                    className="stu-header-icon"
                                    aria-label="Settings"
                                >
                                    <i className="fas fa-cog" aria-hidden="true"></i>
                                </a>
                            )}
                            <button type="button" className="stu-header-out" onClick={studentLogout}>
                                <i className="fas fa-sign-out-alt" aria-hidden="true"></i> Log out
                            </button>
                            {displaySettings && rendererSettings()}
                        </div>
                    </div>
                    <TimeTracker sessionId={sessionId} />
                </header>
            ) : (
                ''
            )}

            {loginTypeFlag?.role === 'therapist' && (
                <HelpPanel open={helpOpen} onClose={() => setHelpOpen(false)} user={props.therapistDetails && props.therapistDetails.user} />
            )}
            <CustomerSupportModal
                open={customerSupport}
                handleClose={() => setCustomerSupport(false)}
            />
            <NotesDropdown
                open={showDropDown}
                activity={activityGame}
                handleClose={() => setShowDropDown(false)}
            />
        </Fragment>
    )
}
const mapStateToProps = (state) => ({
    therapistDetails: selectUser(state),
})

const mapDispatchToProps = {
    getUsers,
}

const HeaderContainer = connect(mapStateToProps, mapDispatchToProps)(Header)

export default HeaderContainer
